// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M13.834 12.5273H10.165L12 8.55273L13.834 12.5273Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 22H2V2H22V22ZM10.9756 6L5.67285 17.4893L7.48926 18.3271L9.24219 14.5273H14.7568L16.5107 18.3271L18.3271 17.4893L13.0244 6H10.9756Z"}}]};

const ModeTextFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'mode-text-filled',
    ref,
    icon: element,
  },
));

ModeTextFilledIcon.displayName = 'ModeTextFilledIcon';

export default ModeTextFilledIcon;
